import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";

type SectionPrivateHeaderProps = {
  title: string;
  onButtonClick?: () => void;
  buttonText?: string;
  existsButton?: boolean;
  extra?: React.ReactNode;
};

export const SectionPrivateHeader = (props: SectionPrivateHeaderProps) => {
  const {
    title,
    onButtonClick,
    buttonText = "Agregar",
    existsButton = true,
    extra,
  } = props;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
      <h2 className="text-3xl font-bold sm:text-4xl">{title}</h2>
      <div className="ml-auto flex items-center gap-3">
        {extra}
        {existsButton && Boolean(onButtonClick) && (
        <div className="ml-auto max-w-fit">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>
            </div>
        )}
      </div>
    </div>
  );
};
